(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-announcement-bar-2"] && !Shopify.designMode) return;
  try {
    
/* JLC 01.2: festes Ende mit Tage-Stelle, danach Uhr weg und title_after (ohne: Band weg). Ohne Ende: bis Mitternacht Gerätezeit. */
document.querySelectorAll("[data-a2-bar]").forEach(el=>{
  if(el.dataset.a2Init)return;el.dataset.a2Init=1;
  const q=k=>el.querySelector('[data-a2="'+k+'"]'),d=q("d"),h=q("h"),m=q("m"),sec=q("s");
  const dw=el.querySelectorAll("[data-a2-dw]"),clock=el.querySelector(".jlc-a2-clock"),t=el.querySelector("[data-a2-t]");
  const end=Date.parse(el.dataset.end),fixed=!isNaN(end);
  const p=n=>String(n).padStart(2,"0");
  let iv;
  const tick=()=>{
    let to=end;
    if(!fixed){const n=new Date();n.setHours(24,0,0,0);to=n.getTime();}
    const s=Math.max(0,Math.floor((to-Date.now())/1000));
    if(fixed&&s<=0){clearInterval(iv);
      if(el.dataset.after){clock.hidden=true;t.textContent=el.dataset.after;}
      else{const w=el.closest(".shopify-section");(w||el).hidden=true;}
      return;}
    const days=fixed?Math.floor(s/86400):0;
    d.textContent=p(days);dw.forEach(x=>x.hidden=!days);
    h.textContent=p(Math.floor((s%86400)/3600));m.textContent=p(Math.floor(s/60)%60);sec.textContent=p(s%60);
  };
  tick();iv=setInterval(tick,1000);
  document.addEventListener("visibilitychange",()=>{if(!document.hidden)tick();});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-announcement-bar"] && !Shopify.designMode) return;
  try {
    
/* 01 announcement bar — countdown. Fixed end date if set, else evergreen per session (sessionStorage). */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-anno]",el=>{
  const h=el.querySelector('[data-cd="h"]'),m=el.querySelector('[data-cd="m"]'),sec=el.querySelector('[data-cd="s"]');
  if(!h)return;
  let end=Date.parse(el.dataset.end);
  if(!end||isNaN(end)){
    /* sessionStorage kann in restriktiven Browsern werfen — dann Timer ohne Speicher */
    const key="jlc-anno-end";let saved=0;
    try{saved=+sessionStorage.getItem(key);}catch(err){}
    if(!saved||saved<Date.now()){saved=Date.now()+(+el.dataset.minutes||120)*60000;try{sessionStorage.setItem(key,saved);}catch(err){}}
    end=saved;
  }
  const p=n=>String(n).padStart(2,"0");
  const tick=()=>{const s=Math.max(0,Math.floor((end-Date.now())/1000));
    h.textContent=p(Math.floor(s/3600));m.textContent=p(Math.floor(s/60)%60);sec.textContent=p(s%60);};
  tick();setInterval(tick,1000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-benefit-overlay"] && !Shopify.designMode) return;
  try {
    
/* 18 benefit cards — flip on tap, one open at a time, card grows to fit its back */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-benefit-section]",sec=>{
  const items=[...sec.querySelectorAll("[data-flip]")];
  const fit=b=>{
    const flip=b.querySelector(".jlc-flip"),front=b.querySelector(".jlc-flip__front"),back=b.querySelector(".jlc-flip__back");
    const on=b.getAttribute("aria-pressed")==="true",fh=front.offsetHeight;
    /* scrollHeight kennt den Rahmen der Rueckseite nicht — ohne den Zuschlag blieb ein 3px-Scrollbalken */
    const bh=back.scrollHeight+(back.offsetHeight-back.clientHeight);
    flip.style.height=(on?Math.max(fh,bh):fh)+"px";
  };
  const set=(b,on)=>{
    b.setAttribute("aria-pressed",on);
    b.querySelector(".jlc-flip__front").setAttribute("aria-hidden",on);
    b.querySelector(".jlc-flip__back").setAttribute("aria-hidden",!on);
    fit(b);
  };
  items.forEach(b=>{
    set(b,false);
    b.addEventListener("click",()=>{
      const on=b.getAttribute("aria-pressed")!=="true";
      items.forEach(o=>{if(o!==b&&o.getAttribute("aria-pressed")==="true")set(o,false);});
      set(b,on);
    });
  });
  addEventListener("resize",()=>items.forEach(fit));
  /* Spaet geladene Schrift oder Bilder aendern die Texthoehe. Ohne Nachmessen
     bliebe die Karte ein paar Pixel zu klein und der Text stuende ueber. */
  addEventListener("load",()=>items.forEach(fit));
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(()=>items.forEach(fit));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-faq"] && !Shopify.designMode) return;
  try {
    
/* 29 FAQ: eine Frage offen. Nach dem Aufklappen max-height auf none, sonst wird der Inhalt beim Drehen abgeschnitten. */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-faq]",box=>{
  box.querySelectorAll(".jlc-faq-head").forEach(h=>h.addEventListener("click",()=>{
    const item=h.parentElement,open=item.hasAttribute("open");
    box.querySelectorAll(".jlc-faq-item").forEach(i=>{
      const b=i.querySelector(".jlc-faq-body");
      if(i.hasAttribute("open")){b.style.maxHeight=b.scrollHeight+"px";b.offsetHeight;}
      i.removeAttribute("open");b.style.maxHeight="";
      i.querySelector(".jlc-faq-sign").textContent="+";i.querySelector(".jlc-faq-head").setAttribute("aria-expanded","false");
    });
    if(!open){
      item.setAttribute("open","");const b=item.querySelector(".jlc-faq-body");
      b.style.maxHeight=b.scrollHeight+"px";h.querySelector(".jlc-faq-sign").textContent="−";h.setAttribute("aria-expanded","true");
      const done=ev=>{if(ev.propertyName!=="max-height")return;b.removeEventListener("transitionend",done);if(item.hasAttribute("open"))b.style.maxHeight="none";};
      b.addEventListener("transitionend",done);
    }
  }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-journey-timeline-2"] && !Shopify.designMode) return;
  try {
    
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})(".jlc-tl2", function (tl) {
  if (tl.dataset.jlcFill2) return;
  tl.dataset.jlcFill2 = "1";
  var steps = Array.prototype.slice.call(tl.querySelectorAll(".jlc-tl-step")), tops = [], height = 0;
  /* Offsets einmal messen statt bei jedem Scroll (Forced Layout), bei resize neu */
  var measure = function () { height = tl.offsetHeight; tops = steps.map(function (st) { return st.offsetTop; }); };
  var update = function () {
    var r = tl.getBoundingClientRect();
    var start = window.innerHeight * 0.85;
    var p = (start - r.top) / (r.height + start - window.innerHeight * 0.25);
    var f = Math.max(0, Math.min(1, p));
    tl.style.setProperty("--tl-fill", f.toFixed(3));
    var reach = f * (height - 20) + 8;
    steps.forEach(function (st, i) { st.classList.toggle("jlc-on", tops[i] + 9 <= reach); });
    var fig = tl.closest(".jlc-jr") && tl.closest(".jlc-jr").querySelector(".jlc-tl2-fig");
    if (fig) {
      /* Bild wechselt, sobald eine Stufe die Bildschirmmitte erreicht, unabhaengig von der Linie */
      var act = 0, mid = window.innerHeight * 0.5;
      steps.forEach(function (st, i) { if (st.getBoundingClientRect().top < mid) act = i; });
      fig.querySelectorAll(".jlc-tl2-f").forEach(function (f) { f.classList.toggle("is-on", +f.dataset.i === act); });
    }
  };
  measure(); update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", function () { measure(); update(); });
  window.addEventListener("load", function () { measure(); update(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-journey-timeline-3"] && !Shopify.designMode) return;
  try {
    
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})(".jlc-tl", function (tl) {
  if (tl.dataset.jlcFill) return;
  tl.dataset.jlcFill = "1";
  var steps = Array.prototype.slice.call(tl.querySelectorAll(".jlc-tl-step")), tops = [], height = 0;
  /* Offsets einmal messen statt bei jedem Scroll (Forced Layout), bei resize neu */
  var measure = function () { height = tl.offsetHeight; tops = steps.map(function (st) { return st.offsetTop; }); };
  var update = function () {
    var r = tl.getBoundingClientRect();
    var start = window.innerHeight * 0.85;
    var p = (start - r.top) / (r.height + start - window.innerHeight * 0.25);
    var f = Math.max(0, Math.min(1, p));
    tl.style.setProperty("--tl-fill", f.toFixed(3));
    var reach = f * (height - 20) + 8;
    steps.forEach(function (st, i) { st.classList.toggle("jlc-on", tops[i] + 9 <= reach); });
  };
  measure(); update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", function () { measure(); update(); });
  window.addEventListener("load", function () { measure(); update(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-journey-timeline"] && !Shopify.designMode) return;
  try {
    
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})(".jlc-tl", function (tl) {
  if (tl.dataset.jlcFill) return;
  tl.dataset.jlcFill = "1";
  var steps = Array.prototype.slice.call(tl.querySelectorAll(".jlc-tl-step")), tops = [], height = 0;
  /* Offsets einmal messen statt bei jedem Scroll (Forced Layout), bei resize neu */
  var measure = function () { height = tl.offsetHeight; tops = steps.map(function (st) { return st.offsetTop; }); };
  var update = function () {
    var r = tl.getBoundingClientRect();
    var start = window.innerHeight * 0.85;
    var p = (start - r.top) / (r.height + start - window.innerHeight * 0.25);
    var f = Math.max(0, Math.min(1, p));
    tl.style.setProperty("--tl-fill", f.toFixed(3));
    var reach = f * (height - 20) + 8;
    steps.forEach(function (st, i) { st.classList.toggle("jlc-on", tops[i] + 9 <= reach); });
  };
  measure(); update();
  window.addEventListener("scroll", update, { passive: true });
  window.addEventListener("resize", function () { measure(); update(); });
  window.addEventListener("load", function () { measure(); update(); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-main-product-2"] && !Shopify.designMode) return;
  try {
    
/* 03–13 main product — one state (selected variant), rendered into: buy block(s), hero image, thumbs, hidden form input, sticky bar */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-main-product]",sec=>{
  const tpl=sec.querySelector("#jlc-buy-tpl");
  document.querySelectorAll("[data-buy-mount]").forEach(m=>{if(!m.children.length)m.appendChild(tpl.content.cloneNode(true));});
  const input=document.querySelector("#jlc-product-form [name=id]"),planInput=document.querySelector("#jlc-product-form [name=selling_plan]");
  const sticky=sec.querySelector("[data-sticky]"),stickySel=sec.querySelector("[data-sticky-sel]");
  /* hero = der Slide, der gezeigt werden soll ("1", "2" … fuer Produktbilder, "b1", "b2" …
     fuer den eigenen Slide einer Paketkarte). bHero merkt sich den zuletzt eingeblendeten
     Bundle-Slide.
     Beim Laden zeigt die Galerie immer das erste Produktbild ("1") und kein Bundle-Bild —
     egal welches Angebot vorgewaehlt ist. Erst eine aktive Auswahl (Karte, Sticky-Picker)
     blendet den Bundle-Slide ein und springt hin. */
  let pkg=+sec.dataset.default||1,hero="1",bHero="",mode=sec.dataset.mode||"once";   /* mode: "sub" = Abo, "once" = Einmalkauf */
  // ?variant=ID in the URL wins for the selected offer, not for the start image
  const urlVar=new URLSearchParams(location.search).get("variant");
  if(urlVar){const b=document.querySelector(`.jlc-bundle[data-variant="${urlVar}"]`);if(b)pkg=+b.dataset.p;}

  /* Die Galerie ist ein Scrollbereich mit Snap-Punkten (siehe CSS). Das Skript bewegt hier
     nichts mehr selbst, es blendet nur den passenden Bundle-Slide ein und scrollt hin.
     Die Reihenfolge macht das Liquid: Bundle-Slides zuerst, dann die Produktbilder. */
  function markThumbs(){sec.querySelectorAll("[data-thumbs] .jlc-thumb").forEach(t=>t.setAttribute("aria-current",t.dataset.p===hero));}
  /* Nur die Galerie neu zeichnen. Beim reinen Bildwechsel per Wisch oder Thumbnail sollen
     Preise, Geschenke und Sticky-Bar nicht mitlaufen. */
  function renderMedia(animate){
    /* Sichtbar ist genau der Bundle-Slide der gewaehlten Karte, die uebrigen nicht. */
    sec.querySelectorAll("[data-bundle-slide]").forEach(h=>{h.hidden=h.dataset.hero!==bHero;});
    const el=slideEl(hero);
    if(el)scrollToSlide(el,animate!==false);
    markThumbs();
    paint();
  }
  function render(){
    const sel0=document.querySelector(`.jlc-bundle[data-p="${pkg}"]`);if(!sel0)return;
    /* Abo nur, wenn der Schalter auf Abo steht UND die Karte einen Plan traegt. */
    const d=sel0.dataset,hasWas=!!d.was,sub=mode==="sub"&&!!d.plan,now=sub?d.nowSub:d.nowOnce,saveTxt=sub?d.saveSub:d.saveOnce;
    document.querySelectorAll(".jlc-buy").forEach(buy=>{
      buy.querySelectorAll(".jlc-bundle").forEach(b=>{
        b.setAttribute("aria-checked",b.dataset.p===String(pkg));
        const cp=b.querySelector("[data-card-price]");if(cp)cp.textContent=(mode==="sub"&&b.dataset.plan)?b.dataset.nowSub:b.dataset.nowOnce;
      });
      buy.querySelectorAll("[data-mode-switch] input").forEach(i=>{i.checked=mode==="sub";});
      buy.querySelectorAll("[data-out-price]").forEach(e=>{if(e.textContent===now)return;e.textContent=now;e.classList.remove("jlc-pop");void e.offsetWidth;e.classList.add("jlc-pop");});
      buy.querySelectorAll("[data-out-was]").forEach(e=>{e.textContent=d.was;e.hidden=!hasWas;});
      const save=buy.querySelector("[data-out-save]");if(save){save.textContent=save.dataset.prefix+" "+saveTxt;save.hidden=!hasWas;}
      const lvl=+d.unlock,gifts=buy.querySelector("[data-gifts]");
      if(gifts){
        const replay=(el,c)=>{el.classList.remove(c);void el.offsetWidth;el.classList.add(c);};
        gifts.querySelectorAll(".jlc-gift").forEach(g=>{
          const lock=+g.dataset.lvl>lvl,was=g.classList.contains("jlc-locked");
          g.classList.toggle("jlc-locked",lock);
          if(was&&!lock)replay(g,"jlc-unlock");
        });
        const note=gifts.querySelector("[data-note]"),max=Math.max(...[...gifts.querySelectorAll(".jlc-gift")].map(g=>+g.dataset.lvl));
        const txt=gifts.getAttribute("data-note-"+Math.min(lvl,3))||"";
        if(note.textContent!==txt){note.textContent=txt;replay(note,"jlc-note-in");}
        note.classList.toggle("jlc-done",lvl>=max);
      }
    });
    if(input)input.value=d.variant;
    if(planInput)planInput.value=sub?d.plan:"";
    const fId=document.querySelector("#jlc-product-form [data-free-id]"),fQty=document.querySelector("#jlc-product-form [data-free-qty]");
    if(fId)fId.value=d.freeId||"";if(fQty)fQty.value=d.freeQty||"0";
    /* Abo-Unterzeile folgt der Karte: jede Variante kann einen eigenen Plan (4 / 8 / 12 Wochen) tragen. */
    if(d.planName)document.querySelectorAll("[data-plan-out]").forEach(o=>{const n=o.hasAttribute("data-lc")?d.planName.charAt(0).toLowerCase()+d.planName.slice(1):d.planName;o.textContent=o.dataset.tpl.replace("[plan]",n);});
    renderMedia();
    if(sticky){
      sticky.querySelector("[data-out-price]").textContent=now;
      stickySel.querySelectorAll("[data-pick-price]").forEach(e=>e.textContent=mode==="sub"?e.dataset.sub:e.dataset.once);
      const w=sticky.querySelector("[data-out-was-line]");if(w){w.textContent=w.dataset.prefix+" "+d.was;w.hidden=!hasWas;}
      const sub=sticky.querySelector("[data-sticky-sub]");if(sub)sub.textContent=d.stickySub;
      stickySel.querySelector("[data-sel-label]").textContent=d.label;
      stickySel.querySelectorAll("li").forEach(li=>li.setAttribute("aria-selected",li.dataset.p===String(pkg)));
    }
  }
  const qtyInput=document.querySelector("#jlc-product-form [name=quantity]");
  /* initial=true: Preise, Karten, Geschenke und Sticky-Bar rendern, die Galerie aber auf dem
     ersten Produktbild lassen (siehe oben). Ohne das Flag springt sie zum Bild des Angebots. */
  const select=(p,initial)=>{pkg=+p;
    const card=sec.querySelector(`.jlc-bundle[data-p="${pkg}"]`);
    if(!initial){hero=String(card&&card.dataset.heroIndex?card.dataset.heroIndex:pkg);bHero=hero;first=0;}
    if(qtyInput&&card&&card.dataset.qty)qtyInput.value=card.dataset.qty;
    render();};
  window.jlSelectBundle=select;window.jlShowMedia=k=>{hero=k;renderMedia();};
  window.jlSetMode=m=>{mode=m==="sub"?"sub":"once";render();};

  /* Galerie-Navigation. Die Pfeile schalten genau ein Bild weiter. Die Reihenfolge steht im
     DOM (Liquid), sichtbar ist davon alles ausser den nicht gewaehlten Bundle-Slides.
     Die Thumbnail-Leiste zeigt fuenf Kacheln und blaettert erst, wenn die Auswahl das
     Fenster verlaesst: vorwaerts setzt das Fenster auf das neue Bild, sodass fuenf frische
     Kacheln erscheinen, rueckwaerts wandert es um genau eine. Dadurch ist nie eine
     Kachel angeschnitten. */
  const strip=sec.querySelector("[data-thumbs]"),tw=sec.querySelector(".jlc-thumbs-wrap"),
        dots=sec.querySelector("[data-gal-dots]"),
        track=sec.querySelector("[data-gal-track]"),PER=5;
  let thumbDrag=false;   /* true, solange eine Ziehbewegung in der Leiste laeuft */
  let first=0;
  const thumbs=()=>strip?[...strip.querySelectorAll(".jlc-thumb")]:[];
  /* Die sichtbaren Slides in ihrer echten Reihenfolge im DOM. */
  const slides=()=>track?[...track.querySelectorAll("[data-hero]")].filter(h=>!h.hidden):[];
  const slideEl=k=>track?track.querySelector(`[data-hero="${CSS.escape(k)}"]:not([hidden])`):null;
  const navList=()=>slides().map(h=>h.dataset.hero);

  /* Hinscrollen. Gerechnet wird ueber die Layout-Werte (offsetLeft/offsetWidth), nicht ueber
     getBoundingClientRect: die Rechtecke haben Nachkommastellen, die sich ueber mehrere Slides
     aufsummieren — auf dem Desktop blieb das Bild dadurch 5 px neben der Mitte stehen.
     offsetLeft bezieht sich bei beiden auf .jlc-gal, die Differenz ist also der Abstand
     innerhalb der Spur und damit genau das, was scrollLeft misst. */
  const noMotion=()=>window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function scrollToSlide(el,smooth){
    if(!track||!el)return;
    const ziel=(el.offsetLeft-track.offsetLeft-track.clientLeft)-(track.clientWidth-el.offsetWidth)/2;
    const delta=ziel-track.scrollLeft;
    if(Math.abs(delta)<1)return;
    /* Weiche Bewegung nur zum Nachbarn. Wer vom letzten Bild aus eine Paketkarte antippt,
       will das Bundle-Bild sehen und keinen Schwenk quer durch die ganze Reihe. */
    const nah=Math.abs(delta)<=el.offsetWidth*1.5;
    /* "instant", nicht "auto": laut Spezifikation heisst auto "nimm das CSS", und im CSS steht
       scroll-behavior:smooth. Mit "auto" lief also auch der Sprung als langer Schwenk. */
    track.scrollTo({left:ziel,behavior:(smooth&&nah&&!noMotion())?"smooth":"instant"});
  }
  /* d Bilder weiter (negativ = zurueck). Ohne Endlos-Schleife: an den Enden ist Schluss,
     die Pfeile sind dort aus (Loop am 10.09.2026 bewusst aufgegeben). */
  function step(d){
    const l=navList();if(!l.length)return;
    const ni=l.indexOf(hero)+d;
    if(ni<0||ni>=l.length)return;
    hero=l[ni];
    /* bHero bleibt stehen: der einmal eingeblendete Bundle-Slide gehoert ab jetzt zur Reihe.
       Wuerde er beim Weiterwischen verschwinden, ruecken alle Bilder um eine Breite nach. */
    const ti=thumbs().findIndex(t=>t.dataset.p===hero);
    if(ti>=0){if(ti>first+PER-1)first=ti;else if(ti<first)first=ti;}
    renderMedia(true);
  }
  function paint(){
    const t=thumbs();
    if(t.length){
      first=Math.min(Math.max(first,0),Math.max(0,t.length-PER));
      const w=t[0].getBoundingClientRect().width,
            g=parseFloat(getComputedStyle(strip).columnGap)||0;
      strip.scrollLeft=first*(w+g);
    }
    const l=navList(),i=l.indexOf(hero),
          pv=tw&&tw.querySelector('[data-td="-1"]'),nx=tw&&tw.querySelector('[data-td="1"]');
    /* Ohne Endlos-Schleife: an den Enden sind die Pfeile aus */
    if(pv)pv.disabled=i<=0;
    if(nx)nx.disabled=i<0||i>=l.length-1;
    if(dots){
      if(dots.children.length!==l.length)dots.innerHTML=l.map(()=>"<i></i>").join("");
      [...dots.children].forEach((d,k)=>d.classList.toggle("jlc-on",k===i));
    }
  }

  /* Gewischt wird vom Browser, nicht von uns. Hier wird nur zugehoert und nachgefuehrt:
     welcher Slide gerade in der Mitte steht, dann Punkte und Thumbnails darauf setzen.

     Hier standen rund 70 Zeilen eigene Touch-Physik: Achsenerkennung, Geschwindigkeit,
     Schwellenwerte, Gummiband. Sie konnten es nie so gut wie die Engine, und ihr
     Zusammenspiel mit dem Umsortieren der Spur war die Ursache des Sprungs beim schnellen
     Wischen (gemessen 10.09.2026: eine Slidebreite zu weit, danach harter Ruck zurueck).
     Nicht wieder einbauen. */
  if(track){
    /* Alle Bilder ausser dem ersten laden faul, damit die Seite schnell oeffnet. Beim ersten
       Anfassen der Galerie werden sie auf sofort umgestellt. Vorher wurde mitten in der
       Wischbewegung geladen und dekodiert, und genau da hakte es — gemeldet 10.09.2026 aus
       dem Inkognito-Fenster, spuerbar ab Bild 2. `loading` von lazy auf eager zu setzen
       startet den Abruf. Absichtlich erst bei Beruehrung: sonst kostet es die Ladezeit. */
    const bilderJetzt=()=>track.querySelectorAll('img[loading="lazy"]').forEach(i=>{i.loading="eager";});
    ["pointerdown","scroll","mouseenter"].forEach(ev=>track.addEventListener(ev,bilderJetzt,{once:true,passive:true}));

    /* Der Slide, dessen Mitte der Mitte des Fensters am naechsten liegt. */
    const centred=()=>{
      const tr=track.getBoundingClientRect(),mid=tr.left+tr.width/2;
      let best=null,bd=Infinity;
      slides().forEach(h=>{
        const r=h.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-mid);
        if(d<bd){bd=d;best=h;}
      });
      return best;
    };
    let raf=0;
    track.addEventListener("scroll",()=>{
      if(raf)return;
      raf=requestAnimationFrame(()=>{
        raf=0;
        const el=centred();
        if(!el||el.dataset.hero===hero)return;
        hero=el.dataset.hero;
        const ti=thumbs().findIndex(t=>t.dataset.p===hero);
        if(ti>=0){if(ti>first+PER-1)first=ti;else if(ti<first)first=ti;}
        markThumbs();
        paint();
      });
    },{passive:true});
    /* Nach dem Drehen des Geraets liegt der Snap-Punkt woanders: ohne Animation nachziehen. */
    addEventListener("resize",()=>{const el=slideEl(hero);if(el)scrollToSlide(el,false);});
  }
  if(tw){
    tw.querySelectorAll(".jlc-thumb-arw").forEach(b=>b.addEventListener("click",()=>step(+b.dataset.td)));
    addEventListener("resize",paint);
  }

  /* Die Thumbnail-Leiste laesst sich auch ziehen — mit der Maus wie mit dem Finger.
     Beim Loslassen rastet sie auf eine ganze Kachel ein, damit die Regel bestehen bleibt,
     dass nie eine angeschnitten ist. `first` wird dabei mitgezogen, sonst springt die
     Leiste beim naechsten render() auf ihren alten Stand zurueck. Wer gezogen hat, waehlt
     kein Bild aus: thumbDrag sperrt den folgenden Klick. */
  if(strip){
    let down=false,axis=null,sx=0,sy=0,base=0;
    const stepPx=()=>{
      const t=thumbs();if(!t.length)return 0;
      return t[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(strip).columnGap)||0);
    };
    const stop=()=>{
      if(!down)return;
      down=false;strip.style.scrollBehavior="";strip.classList.remove("jlc-drag");
      if(axis!=="x"){axis=null;return;}
      axis=null;
      const w=stepPx();
      if(w)first=Math.round(strip.scrollLeft/w);
      paint();
      setTimeout(()=>{thumbDrag=false;},0);
    };
    strip.addEventListener("dragstart",e=>e.preventDefault());
    strip.addEventListener("pointerdown",e=>{
      if(e.button)return;
      down=true;axis=null;sx=e.clientX;sy=e.clientY;base=strip.scrollLeft;
    });
    strip.addEventListener("pointermove",e=>{
      if(!down)return;
      if(e.pointerType==="mouse"&&!(e.buttons&1)){stop();return;}   /* ausserhalb losgelassen */
      const dx=e.clientX-sx,dy=e.clientY-sy;
      if(!axis){
        if(Math.abs(dx)<5&&Math.abs(dy)<5)return;
        axis=Math.abs(dx)>Math.abs(dy)?"x":"y";
        if(axis!=="x"){down=false;return;}
        thumbDrag=true;strip.classList.add("jlc-drag");
        strip.style.scrollBehavior="auto";
        if(strip.setPointerCapture)try{strip.setPointerCapture(e.pointerId);}catch(err){}
      }
      e.preventDefault();
      strip.scrollLeft=base-dx;
    });
    strip.addEventListener("pointerup",stop);
    strip.addEventListener("pointercancel",stop);
    window.addEventListener("pointerup",stop);
    window.addEventListener("blur",stop);
  }
  if(!window.jlMainBound){window.jlMainBound=true;
    document.addEventListener("click",e=>{
      const b=e.target.closest(".jlc-bundle");if(b){window.jlSelectBundle(b.dataset.p);return;}
      const t=e.target.closest("[data-thumbs] .jlc-thumb");if(t&&!thumbDrag)window.jlShowMedia(t.dataset.p);   /* Thumbnails wechseln nur das Bild; die Bundle-Auswahl springt ihrerseits auf das passende Bild */
    });
    document.addEventListener("change",e=>{const i=e.target.closest&&e.target.closest("[data-mode-switch] input");if(i)window.jlSetMode(i.checked?"sub":"once");});
    document.addEventListener("keydown",e=>{const b=e.target.closest&&e.target.closest(".jlc-bundle");if(b&&(e.key==="Enter"||e.key===" ")){e.preventDefault();window.jlSelectBundle(b.dataset.p);}});
  }

  /* sticky picker (drop-up) — mit Tastatur: Pfeile bewegen, Enter/Leertaste waehlt, Escape schliesst */
  if(stickySel){
    const btn=stickySel.querySelector(".jlc-sticky-sel__btn"),opts=()=>[...stickySel.querySelectorAll("li")];
    const toggle=o=>{stickySel.classList.toggle("jlc-open",o);btn.setAttribute("aria-expanded",o);
      if(o){const cur=opts().find(li=>li.getAttribute("aria-selected")==="true")||opts()[0];if(cur)cur.focus();}};
    btn.addEventListener("click",()=>toggle(!stickySel.classList.contains("jlc-open")));
    btn.addEventListener("keydown",e=>{if(e.key==="ArrowUp"||e.key==="ArrowDown"){e.preventDefault();toggle(true);}});
    opts().forEach(li=>{
      li.addEventListener("click",()=>{select(li.dataset.p);toggle(false);});
      li.addEventListener("keydown",e=>{
        const l=opts(),i=l.indexOf(li);
        if(e.key==="ArrowDown"){e.preventDefault();(l[i+1]||l[0]).focus();}
        else if(e.key==="ArrowUp"){e.preventDefault();(l[i-1]||l[l.length-1]).focus();}
        else if(e.key==="Enter"||e.key===" "){e.preventDefault();select(li.dataset.p);toggle(false);btn.focus();}
        else if(e.key==="Tab")toggle(false);
      });
    });
    document.addEventListener("click",e=>{if(!stickySel.contains(e.target))toggle(false);});
    document.addEventListener("keydown",e=>{if(e.key==="Escape"&&stickySel.classList.contains("jlc-open")){toggle(false);btn.focus();}});
  }
  /* bundle-repeat section (25) rendered later / re-rendered in the editor: mount there too */
  document.addEventListener("shopify:section:load",e=>e.target.querySelectorAll("[data-buy-mount]").forEach(m=>{if(!m.children.length){m.appendChild(tpl.content.cloneNode(true));render();}}));
  /* sticky bar: erscheint, sobald der Haupt-ATC nach oben rausgescrollt ist — und verschwindet
     wieder, solange irgendein Kaufbutton (auch der in JLC 25) im Bild ist. Vorher blieb sie bis
     zum Seitenende stehen und hat den zweiten Kaufblock und den Footer verdeckt. */
  if(sticky){
    const anchor=sec.querySelector("[data-buy-main] .jlc-btn");
    const buyBtns=()=>[...document.querySelectorAll("[data-buy-mount] .jlc-btn")];
    const anyBuyVisible=()=>buyBtns().some(b=>{const r=b.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;});
    const st=()=>{
      const on=!!anchor&&anchor.getBoundingClientRect().bottom<0&&!anyBuyVisible();
      sticky.classList.toggle("jlc-show",on);
      document.body.classList.toggle("jlc-sticky-on",on);
    };
    addEventListener("scroll",st,{passive:true});addEventListener("resize",st);st();
  }
  /* Desktop: die linke Spalte (Galerie + Videostreifen) ist sticky. Ist sie hoeher als der
     Viewport, soll sie mit der Unterkante einrasten, sonst sind die Videos nie zu sehen. */
  const col=sec.querySelector(".jlc-buy-wrap>div:first-child");
  if(col){
    const colTop=()=>{
      if(innerWidth<900){col.style.removeProperty("--jlc-col-top");return;}
      const h=col.offsetHeight,free=innerHeight-100-24;
      col.style.setProperty("--jlc-col-top",(h>free?innerHeight-h-24:100)+"px");
    };
    colTop();addEventListener("resize",colTop);addEventListener("load",colTop);
    if("ResizeObserver" in window)new ResizeObserver(colTop).observe(col);
  }
  /* Scarcity-Puls nur, solange der Kaufblock im Bild ist */
  if("IntersectionObserver" in window){
    const sio=new IntersectionObserver(es=>es.forEach(e=>e.target.classList.toggle("jlc-anim",e.isIntersecting)),{threshold:.1});
    document.querySelectorAll(".jlc-scar").forEach(s=>sio.observe(s));
  }else document.querySelectorAll(".jlc-scar").forEach(s=>s.classList.add("jlc-anim"));
  /* Tabs (acc_style "tabs"): Klick zeigt das passende Panel, Theme-Editor springt zum angeklickten Block */
  sec.querySelectorAll("[data-tabs]").forEach(box=>{
    const show=id=>{box.querySelectorAll("[data-tab]").forEach(t=>{const on=t.dataset.tab===id;t.classList.toggle("is-on",on);t.setAttribute("aria-selected",on?"true":"false");});
      box.querySelectorAll("[data-tab-panel]").forEach(p=>{p.hidden=p.dataset.tabPanel!==id;});};
    box.querySelectorAll("[data-tab]").forEach(t=>t.addEventListener("click",()=>show(t.dataset.tab)));
    box.addEventListener("shopify:block:select",e=>{const p=e.target.closest&&e.target.closest("[data-tab-panel]");if(p)show(p.dataset.tabPanel);});
  });
  /* accordion: one open at a time. Nach dem Aufklappen max-height auf none, sonst wurde der
     Inhalt beim Drehen des Geraets oder bei Bildern im Text abgeschnitten. */
  sec.querySelectorAll("[data-acc] .jlc-acc-head").forEach(h=>h.addEventListener("click",()=>{
    const item=h.parentElement,open=item.hasAttribute("open");
    /* data-acc-multi (acc_style "offen"): jedes Akkordeon klappt fuer sich, die anderen bleiben, wie sie sind */
    if(h.closest("[data-acc-multi]")){
      const b=item.querySelector(".jlc-acc-body"),sg=h.querySelector(".jlc-acc-sign");
      if(open){b.style.maxHeight=b.scrollHeight+"px";b.offsetHeight;b.style.maxHeight="0px";item.removeAttribute("open");sg.textContent="+";h.setAttribute("aria-expanded","false");}
      else{item.setAttribute("open","");b.style.maxHeight=b.scrollHeight+"px";sg.textContent="−";h.setAttribute("aria-expanded","true");
        const done=ev=>{if(ev.propertyName!=="max-height")return;b.removeEventListener("transitionend",done);if(item.hasAttribute("open"))b.style.maxHeight="none";};
        b.addEventListener("transitionend",done);}
      return;
    }
    sec.querySelectorAll("[data-acc] .jlc-acc-item").forEach(i=>{
      const b=i.querySelector(".jlc-acc-body");
      if(i.hasAttribute("open")){b.style.maxHeight=b.scrollHeight+"px";b.offsetHeight;}
      i.removeAttribute("open");b.style.maxHeight="";
      i.querySelector(".jlc-acc-sign").textContent="+";i.querySelector(".jlc-acc-head").setAttribute("aria-expanded","false");
    });
    if(!open){
      item.setAttribute("open","");const b=item.querySelector(".jlc-acc-body");
      b.style.maxHeight=b.scrollHeight+"px";h.querySelector(".jlc-acc-sign").textContent="−";h.setAttribute("aria-expanded","true");
      const done=ev=>{if(ev.propertyName!=="max-height")return;b.removeEventListener("transitionend",done);if(item.hasAttribute("open"))b.style.maxHeight="none";};
      b.addEventListener("transitionend",done);
    }
  }));
  /* hero video strip: Pfeile, Punkte, Loop und Drag macht jlc-base.js (data-rail data-loop);
     hier nur die stummen Inline-Videos starten */
  const hv=sec.querySelector("[data-hero-vids]");
  if(hv&&window.jlInlineVideos)window.jlInlineVideos(hv);
  select(pkg,true);
});

/* 12 ATC — der Button legt per AJAX in den Warenkorb. Was danach passiert, steuert das Setting
   atc_target (data-target am Formular): "checkout" schickt die Seite sofort auf /checkout, der
   Button bleibt solange im Ladezustand (aria-busy, Spinner aus jlc-base.css). "drawer" rendert
   die Drawer-Section neu und oeffnet sie; laesst sich der Drawer nicht sichtbar machen, fuehrt
   der letzte Ausweg auf /cart. Steht selling_plan im Formular, geht er mit in den Warenkorb,
   damit die Zeile als Abo im Checkout landet. */
(function(){
  var form=document.getElementById("jlc-product-form");
  if(!form||form.dataset.jlcAjax)return;
  form.dataset.jlcAjax="1";
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
  function drawerEl(){return document.querySelector("cart-drawer");}
  function swap(html,sel,target){
    if(!html||!target)return;
    var fresh=new DOMParser().parseFromString(html,"text/html").querySelector(sel);
    if(fresh)target.innerHTML=fresh.innerHTML;
  }
  form.addEventListener("submit",function(e){
    e.preventDefault();
    if(form.dataset.jlcBusy)return;   /* zweiter Klick waehrend des Ladens: ignorieren, sonst liegt der Artikel doppelt drin */
    var idInput=form.querySelector("[name=id]"),qtyInput=form.querySelector("[name=quantity]"),planInput=form.querySelector("[name=selling_plan]");
    if(!idInput)return;
    form.dataset.jlcBusy="1";
    var btns=document.querySelectorAll('button[form="jlc-product-form"][name="add"]');
    btns.forEach(function(b){b.setAttribute("aria-busy","true");});
    var toCheckout=(form.dataset.target||"drawer")==="checkout";
    var drawer=toCheckout?null:drawerEl();
    var item={id:parseInt(idInput.value,10),quantity:parseInt(qtyInput&&qtyInput.value,10)||1};
    if(planInput&&planInput.value)item.selling_plan=parseInt(planInput.value,10);
    var items=[item];
    var fId=form.querySelector("[data-free-id]"),fQty=form.querySelector("[data-free-qty]"),fNote=form.querySelector("[data-free-note]");
    if(fId&&fId.value&&fQty&&parseInt(fQty.value,10)>0){
      var free={id:parseInt(fId.value,10),quantity:parseInt(fQty.value,10)};
      if(fNote&&fNote.value)free.properties={"Zugabe":fNote.value};
      items.push(free);
    }
    /* Zugaben als echte Produkte: jede freigeschaltete Geschenk-Kachel mit Produkt kommt einmal mit.
       Die Stufe liefert die gewaehlte Karte; Kaufblock steht zweimal auf der Seite, daher je ID nur einmal. */
    var selCard=document.querySelector('.jlc-buy .jlc-bundle[aria-checked="true"]'),lvl=selCard?(+selCard.dataset.unlock||1):1,seen={};
    document.querySelectorAll(".jlc-buy [data-gifts] .jlc-gift[data-gift-id]").forEach(function(g){
      var gid=g.dataset.giftId;if(!gid||seen[gid]||+g.dataset.lvl>lvl)return;seen[gid]=1;
      items.push({id:parseInt(gid,10),quantity:1,properties:{"Zugabe":"Gratis"}});
    });
    var body={items:items};
    if(drawer){body.sections="cart-drawer,cart-icon-bubble";body.sections_url=window.location.pathname;}
    /* Zwei getrennte Ketten. Vorher fing EIN catch alles: auch einen Fehler, der erst nach
       erfolgreichem Add beim Aktualisieren des Drawers passierte — Reaktion war ein nativer
       Formular-Submit, also ein zweiter POST und der Artikel lag doppelt im Warenkorb.
       Jetzt: schlaegt der Request fehl → nativ abschicken (Artikel ist noch nicht drin).
       Schlaegt danach die UI fehl → einfach auf /cart, der Artikel ist bereits drin. */
    var added=false;
    /* Direkt zum Checkout heisst: genau dieses Bundle kaufen. Deshalb vorher leeren, sonst lag
       nach Zurueck und erneutem Klick das alte Bundle noch mit drin (doppelter Preis). */
    (toCheckout?fetch(root+"cart/clear.js",{method:"POST",headers:{Accept:"application/json"}}):Promise.resolve())
      .then(function(){return fetch(root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/javascript"},body:JSON.stringify(body)});})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d&&d.status)throw new Error(d.description||d.message||"add failed");
        added=true;
        return d;
      })
      .then(function(d){
        try{
          if(toCheckout){window.location.href=root+"checkout";return;}
          if(!drawer){window.location.href=root+"cart";return;}
          if(d.sections){
            swap(d.sections["cart-drawer"],"cart-drawer",drawer);
            swap(d.sections["cart-icon-bubble"],".shopify-section",document.getElementById("cart-icon-bubble"));
          }
          drawer.classList.remove("is-empty");
          document.dispatchEvent(new CustomEvent("cartQuantityUpdated"));
          if(typeof drawer.open==="function"){try{drawer.open();}catch(err){}}
          drawer.classList.add("active");
          var inner=document.getElementById("CartDrawer");
          if(inner)inner.classList.add("active");
          /* Scroll-Lock erst, wenn der Drawer wirklich im Bild ist; sonst blieb die Seite
             gesperrt, ohne dass etwas zu sehen war. Nach zwei Frames plus Animationszeit messen. */
          setTimeout(function(){
            var r=drawer.getBoundingClientRect(),vis=r.width>0&&r.height>0&&r.left<window.innerWidth&&getComputedStyle(drawer).visibility!=="hidden";
            if(vis)document.body.classList.add("overflow-hidden");
            else window.location.href=root+"cart";
          },450);
        }catch(err){window.location.href=root+"cart";}
      })
      .catch(function(){
        if(added){window.location.href=root+"cart";return;}
        form.removeAttribute("data-jlc-ajax");HTMLFormElement.prototype.submit.call(form);
      })
      .then(function(){
        /* Beim Sprung zum Checkout bleibt der Spinner stehen, bis die neue Seite da ist. */
        if(toCheckout&&added)return;
        delete form.dataset.jlcBusy;btns.forEach(function(b){b.removeAttribute("aria-busy");});
      });
  });
  /* Zurueck vom Checkout: der Browser holt die Seite aus dem Back-Forward-Cache, samt Spinner
     und gesetztem jlcBusy. Der Button drehte dann endlos und nahm keinen Klick mehr an.
     Icon und Drawer zeigen ausserdem noch den Warenkorb von vor dem Klick, also neu holen.
     Das gilt auch, wenn Chrome die Seite nicht aus dem Cache holt, sondern das HTML von damals
     aus dem HTTP-Cache neu aufbaut (persisted ist dann false, der Navigationstyp back_forward). */
  window.addEventListener("pageshow",function(e){
    var nav=performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];
    if(!e.persisted&&!(nav&&nav.type==="back_forward"))return;
    delete form.dataset.jlcBusy;
    document.querySelectorAll('button[form="jlc-product-form"][name="add"]').forEach(function(b){b.removeAttribute("aria-busy");});
    fetch(root+"?sections=cart-drawer,cart-icon-bubble",{cache:"no-store"}).then(function(r){return r.json();}).then(function(s){
      var drawer=drawerEl();
      swap(s["cart-icon-bubble"],".shopify-section",document.getElementById("cart-icon-bubble"));
      swap(s["cart-drawer"],"cart-drawer",drawer);
      var fresh=s["cart-drawer"]&&new DOMParser().parseFromString(s["cart-drawer"],"text/html").querySelector("cart-drawer");
      if(drawer&&fresh)drawer.classList.toggle("is-empty",fresh.classList.contains("is-empty"));
    }).catch(function(){});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-main-product"] && !Shopify.designMode) return;
  try {
    
/* 03–13 main product — one state (selected variant), rendered into: buy block(s), hero image, thumbs, hidden form input, sticky bar */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-main-product]",sec=>{
  const tpl=sec.querySelector("#jlc-buy-tpl");
  document.querySelectorAll("[data-buy-mount]").forEach(m=>{if(!m.children.length)m.appendChild(tpl.content.cloneNode(true));});
  const input=document.querySelector("#jlc-product-form [name=id]"),planInput=document.querySelector("#jlc-product-form [name=selling_plan]");
  const sticky=sec.querySelector("[data-sticky]"),stickySel=sec.querySelector("[data-sticky-sel]");
  /* hero = der Slide, der gezeigt werden soll ("1", "2" … fuer Produktbilder, "b1", "b2" …
     fuer den eigenen Slide einer Paketkarte). bHero merkt sich den zuletzt eingeblendeten
     Bundle-Slide.
     Beim Laden zeigt die Galerie immer das erste Produktbild ("1") und kein Bundle-Bild —
     egal welches Angebot vorgewaehlt ist. Erst eine aktive Auswahl (Karte, Sticky-Picker)
     blendet den Bundle-Slide ein und springt hin. */
  let pkg=+sec.dataset.default||1,hero="1",bHero="",mode=sec.dataset.mode||"once";   /* mode: "sub" = Abo, "once" = Einmalkauf */
  // ?variant=ID in the URL wins for the selected offer, not for the start image
  const urlVar=new URLSearchParams(location.search).get("variant");
  if(urlVar){const b=document.querySelector(`.jlc-bundle[data-variant="${urlVar}"]`);if(b)pkg=+b.dataset.p;}

  /* Die Galerie ist ein Scrollbereich mit Snap-Punkten (siehe CSS). Das Skript bewegt hier
     nichts mehr selbst, es blendet nur den passenden Bundle-Slide ein und scrollt hin.
     Die Reihenfolge macht das Liquid: Bundle-Slides zuerst, dann die Produktbilder. */
  function markThumbs(){sec.querySelectorAll("[data-thumbs] .jlc-thumb").forEach(t=>t.setAttribute("aria-current",t.dataset.p===hero));}
  /* Nur die Galerie neu zeichnen. Beim reinen Bildwechsel per Wisch oder Thumbnail sollen
     Preise, Geschenke und Sticky-Bar nicht mitlaufen. */
  function renderMedia(animate){
    /* Sichtbar ist genau der Bundle-Slide der gewaehlten Karte, die uebrigen nicht. */
    sec.querySelectorAll("[data-bundle-slide]").forEach(h=>{h.hidden=h.dataset.hero!==bHero;});
    const el=slideEl(hero);
    if(el)scrollToSlide(el,animate!==false);
    markThumbs();
    paint();
  }
  function render(){
    const sel0=document.querySelector(`.jlc-bundle[data-p="${pkg}"]`);if(!sel0)return;
    /* Abo nur, wenn der Schalter auf Abo steht UND die Karte einen Plan traegt. */
    const d=sel0.dataset,hasWas=!!d.was,sub=mode==="sub"&&!!d.plan,now=sub?d.nowSub:d.nowOnce,saveTxt=sub?d.saveSub:d.saveOnce;
    document.querySelectorAll(".jlc-buy").forEach(buy=>{
      buy.querySelectorAll(".jlc-bundle").forEach(b=>{
        b.setAttribute("aria-checked",b.dataset.p===String(pkg));
        const cp=b.querySelector("[data-card-price]");if(cp)cp.textContent=(mode==="sub"&&b.dataset.plan)?b.dataset.nowSub:b.dataset.nowOnce;
      });
      buy.querySelectorAll("[data-mode-switch] input").forEach(i=>{i.checked=mode==="sub";});
      buy.querySelectorAll("[data-out-price]").forEach(e=>e.textContent=now);
      buy.querySelectorAll("[data-out-was]").forEach(e=>{e.textContent=d.was;e.hidden=!hasWas;});
      const save=buy.querySelector("[data-out-save]");if(save){save.textContent=save.dataset.prefix+" "+saveTxt;save.hidden=!hasWas;}
      const lvl=+d.unlock,gifts=buy.querySelector("[data-gifts]");
      if(gifts){
        gifts.querySelectorAll(".jlc-gift").forEach(g=>g.classList.toggle("jlc-locked",+g.dataset.lvl>lvl));
        const note=gifts.querySelector("[data-note]"),max=Math.max(...[...gifts.querySelectorAll(".jlc-gift")].map(g=>+g.dataset.lvl));
        note.textContent=gifts.getAttribute("data-note-"+Math.min(lvl,3))||"";note.classList.toggle("jlc-done",lvl>=max);
      }
    });
    if(input)input.value=d.variant;
    if(planInput)planInput.value=sub?d.plan:"";
    const fId=document.querySelector("#jlc-product-form [data-free-id]"),fQty=document.querySelector("#jlc-product-form [data-free-qty]");
    if(fId)fId.value=d.freeId||"";if(fQty)fQty.value=d.freeQty||"0";
    /* Abo-Unterzeile folgt der Karte: jede Variante kann einen eigenen Plan (4 / 8 / 12 Wochen) tragen. */
    if(d.planName)document.querySelectorAll("[data-plan-out]").forEach(o=>{const n=o.hasAttribute("data-lc")?d.planName.charAt(0).toLowerCase()+d.planName.slice(1):d.planName;o.textContent=o.dataset.tpl.replace("[plan]",n);});
    renderMedia();
    if(sticky){
      sticky.querySelector("[data-out-price]").textContent=now;
      stickySel.querySelectorAll("[data-pick-price]").forEach(e=>e.textContent=mode==="sub"?e.dataset.sub:e.dataset.once);
      const w=sticky.querySelector("[data-out-was-line]");if(w){w.textContent=w.dataset.prefix+" "+d.was;w.hidden=!hasWas;}
      const sub=sticky.querySelector("[data-sticky-sub]");if(sub)sub.textContent=d.stickySub;
      stickySel.querySelector("[data-sel-label]").textContent=d.label;
      stickySel.querySelectorAll("li").forEach(li=>li.setAttribute("aria-selected",li.dataset.p===String(pkg)));
    }
  }
  const qtyInput=document.querySelector("#jlc-product-form [name=quantity]");
  /* initial=true: Preise, Karten, Geschenke und Sticky-Bar rendern, die Galerie aber auf dem
     ersten Produktbild lassen (siehe oben). Ohne das Flag springt sie zum Bild des Angebots. */
  const select=(p,initial)=>{pkg=+p;
    const card=sec.querySelector(`.jlc-bundle[data-p="${pkg}"]`);
    if(!initial){hero=String(card&&card.dataset.heroIndex?card.dataset.heroIndex:pkg);bHero=hero;first=0;}
    if(qtyInput&&card&&card.dataset.qty)qtyInput.value=card.dataset.qty;
    render();};
  window.jlSelectBundle=select;window.jlShowMedia=k=>{hero=k;renderMedia();};
  window.jlSetMode=m=>{mode=m==="sub"?"sub":"once";render();};

  /* Galerie-Navigation. Die Pfeile schalten genau ein Bild weiter. Die Reihenfolge steht im
     DOM (Liquid), sichtbar ist davon alles ausser den nicht gewaehlten Bundle-Slides.
     Die Thumbnail-Leiste zeigt fuenf Kacheln und blaettert erst, wenn die Auswahl das
     Fenster verlaesst: vorwaerts setzt das Fenster auf das neue Bild, sodass fuenf frische
     Kacheln erscheinen, rueckwaerts wandert es um genau eine. Dadurch ist nie eine
     Kachel angeschnitten. */
  const strip=sec.querySelector("[data-thumbs]"),tw=sec.querySelector(".jlc-thumbs-wrap"),
        dots=sec.querySelector("[data-gal-dots]"),
        track=sec.querySelector("[data-gal-track]"),PER=5;
  let thumbDrag=false;   /* true, solange eine Ziehbewegung in der Leiste laeuft */
  let first=0;
  const thumbs=()=>strip?[...strip.querySelectorAll(".jlc-thumb")]:[];
  /* Die sichtbaren Slides in ihrer echten Reihenfolge im DOM. */
  const slides=()=>track?[...track.querySelectorAll("[data-hero]")].filter(h=>!h.hidden):[];
  const slideEl=k=>track?track.querySelector(`[data-hero="${CSS.escape(k)}"]:not([hidden])`):null;
  const navList=()=>slides().map(h=>h.dataset.hero);

  /* Hinscrollen. Gerechnet wird ueber die Layout-Werte (offsetLeft/offsetWidth), nicht ueber
     getBoundingClientRect: die Rechtecke haben Nachkommastellen, die sich ueber mehrere Slides
     aufsummieren — auf dem Desktop blieb das Bild dadurch 5 px neben der Mitte stehen.
     offsetLeft bezieht sich bei beiden auf .jlc-gal, die Differenz ist also der Abstand
     innerhalb der Spur und damit genau das, was scrollLeft misst. */
  const noMotion=()=>window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function scrollToSlide(el,smooth){
    if(!track||!el)return;
    const ziel=(el.offsetLeft-track.offsetLeft-track.clientLeft)-(track.clientWidth-el.offsetWidth)/2;
    const delta=ziel-track.scrollLeft;
    if(Math.abs(delta)<1)return;
    /* Weiche Bewegung nur zum Nachbarn. Wer vom letzten Bild aus eine Paketkarte antippt,
       will das Bundle-Bild sehen und keinen Schwenk quer durch die ganze Reihe. */
    const nah=Math.abs(delta)<=el.offsetWidth*1.5;
    /* "instant", nicht "auto": laut Spezifikation heisst auto "nimm das CSS", und im CSS steht
       scroll-behavior:smooth. Mit "auto" lief also auch der Sprung als langer Schwenk. */
    track.scrollTo({left:ziel,behavior:(smooth&&nah&&!noMotion())?"smooth":"instant"});
  }
  /* d Bilder weiter (negativ = zurueck). Ohne Endlos-Schleife: an den Enden ist Schluss,
     die Pfeile sind dort aus (Loop am 10.09.2026 bewusst aufgegeben). */
  function step(d){
    const l=navList();if(!l.length)return;
    const ni=l.indexOf(hero)+d;
    if(ni<0||ni>=l.length)return;
    hero=l[ni];
    /* bHero bleibt stehen: der einmal eingeblendete Bundle-Slide gehoert ab jetzt zur Reihe.
       Wuerde er beim Weiterwischen verschwinden, ruecken alle Bilder um eine Breite nach. */
    const ti=thumbs().findIndex(t=>t.dataset.p===hero);
    if(ti>=0){if(ti>first+PER-1)first=ti;else if(ti<first)first=ti;}
    renderMedia(true);
  }
  function paint(){
    const t=thumbs();
    if(t.length){
      first=Math.min(Math.max(first,0),Math.max(0,t.length-PER));
      const w=t[0].getBoundingClientRect().width,
            g=parseFloat(getComputedStyle(strip).columnGap)||0;
      strip.scrollLeft=first*(w+g);
    }
    const l=navList(),i=l.indexOf(hero),
          pv=tw&&tw.querySelector('[data-td="-1"]'),nx=tw&&tw.querySelector('[data-td="1"]');
    /* Ohne Endlos-Schleife: an den Enden sind die Pfeile aus */
    if(pv)pv.disabled=i<=0;
    if(nx)nx.disabled=i<0||i>=l.length-1;
    if(dots){
      if(dots.children.length!==l.length)dots.innerHTML=l.map(()=>"<i></i>").join("");
      [...dots.children].forEach((d,k)=>d.classList.toggle("jlc-on",k===i));
    }
  }

  /* Gewischt wird vom Browser, nicht von uns. Hier wird nur zugehoert und nachgefuehrt:
     welcher Slide gerade in der Mitte steht, dann Punkte und Thumbnails darauf setzen.

     Hier standen rund 70 Zeilen eigene Touch-Physik: Achsenerkennung, Geschwindigkeit,
     Schwellenwerte, Gummiband. Sie konnten es nie so gut wie die Engine, und ihr
     Zusammenspiel mit dem Umsortieren der Spur war die Ursache des Sprungs beim schnellen
     Wischen (gemessen 10.09.2026: eine Slidebreite zu weit, danach harter Ruck zurueck).
     Nicht wieder einbauen. */
  if(track){
    /* Alle Bilder ausser dem ersten laden faul, damit die Seite schnell oeffnet. Beim ersten
       Anfassen der Galerie werden sie auf sofort umgestellt. Vorher wurde mitten in der
       Wischbewegung geladen und dekodiert, und genau da hakte es — gemeldet 10.09.2026 aus
       dem Inkognito-Fenster, spuerbar ab Bild 2. `loading` von lazy auf eager zu setzen
       startet den Abruf. Absichtlich erst bei Beruehrung: sonst kostet es die Ladezeit. */
    const bilderJetzt=()=>track.querySelectorAll('img[loading="lazy"]').forEach(i=>{i.loading="eager";});
    ["pointerdown","scroll","mouseenter"].forEach(ev=>track.addEventListener(ev,bilderJetzt,{once:true,passive:true}));

    /* Der Slide, dessen Mitte der Mitte des Fensters am naechsten liegt. */
    const centred=()=>{
      const tr=track.getBoundingClientRect(),mid=tr.left+tr.width/2;
      let best=null,bd=Infinity;
      slides().forEach(h=>{
        const r=h.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-mid);
        if(d<bd){bd=d;best=h;}
      });
      return best;
    };
    let raf=0;
    track.addEventListener("scroll",()=>{
      if(raf)return;
      raf=requestAnimationFrame(()=>{
        raf=0;
        const el=centred();
        if(!el||el.dataset.hero===hero)return;
        hero=el.dataset.hero;
        const ti=thumbs().findIndex(t=>t.dataset.p===hero);
        if(ti>=0){if(ti>first+PER-1)first=ti;else if(ti<first)first=ti;}
        markThumbs();
        paint();
      });
    },{passive:true});
    /* Nach dem Drehen des Geraets liegt der Snap-Punkt woanders: ohne Animation nachziehen. */
    addEventListener("resize",()=>{const el=slideEl(hero);if(el)scrollToSlide(el,false);});
  }
  if(tw){
    tw.querySelectorAll(".jlc-thumb-arw").forEach(b=>b.addEventListener("click",()=>step(+b.dataset.td)));
    addEventListener("resize",paint);
  }

  /* Die Thumbnail-Leiste laesst sich auch ziehen — mit der Maus wie mit dem Finger.
     Beim Loslassen rastet sie auf eine ganze Kachel ein, damit die Regel bestehen bleibt,
     dass nie eine angeschnitten ist. `first` wird dabei mitgezogen, sonst springt die
     Leiste beim naechsten render() auf ihren alten Stand zurueck. Wer gezogen hat, waehlt
     kein Bild aus: thumbDrag sperrt den folgenden Klick. */
  if(strip){
    let down=false,axis=null,sx=0,sy=0,base=0;
    const stepPx=()=>{
      const t=thumbs();if(!t.length)return 0;
      return t[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(strip).columnGap)||0);
    };
    const stop=()=>{
      if(!down)return;
      down=false;strip.style.scrollBehavior="";strip.classList.remove("jlc-drag");
      if(axis!=="x"){axis=null;return;}
      axis=null;
      const w=stepPx();
      if(w)first=Math.round(strip.scrollLeft/w);
      paint();
      setTimeout(()=>{thumbDrag=false;},0);
    };
    strip.addEventListener("dragstart",e=>e.preventDefault());
    strip.addEventListener("pointerdown",e=>{
      if(e.button)return;
      down=true;axis=null;sx=e.clientX;sy=e.clientY;base=strip.scrollLeft;
    });
    strip.addEventListener("pointermove",e=>{
      if(!down)return;
      if(e.pointerType==="mouse"&&!(e.buttons&1)){stop();return;}   /* ausserhalb losgelassen */
      const dx=e.clientX-sx,dy=e.clientY-sy;
      if(!axis){
        if(Math.abs(dx)<5&&Math.abs(dy)<5)return;
        axis=Math.abs(dx)>Math.abs(dy)?"x":"y";
        if(axis!=="x"){down=false;return;}
        thumbDrag=true;strip.classList.add("jlc-drag");
        strip.style.scrollBehavior="auto";
        if(strip.setPointerCapture)try{strip.setPointerCapture(e.pointerId);}catch(err){}
      }
      e.preventDefault();
      strip.scrollLeft=base-dx;
    });
    strip.addEventListener("pointerup",stop);
    strip.addEventListener("pointercancel",stop);
    window.addEventListener("pointerup",stop);
    window.addEventListener("blur",stop);
  }
  if(!window.jlMainBound){window.jlMainBound=true;
    document.addEventListener("click",e=>{
      const b=e.target.closest(".jlc-bundle");if(b){window.jlSelectBundle(b.dataset.p);return;}
      const t=e.target.closest("[data-thumbs] .jlc-thumb");if(t&&!thumbDrag)window.jlShowMedia(t.dataset.p);   /* Thumbnails wechseln nur das Bild; die Bundle-Auswahl springt ihrerseits auf das passende Bild */
    });
    document.addEventListener("change",e=>{const i=e.target.closest&&e.target.closest("[data-mode-switch] input");if(i)window.jlSetMode(i.checked?"sub":"once");});
    document.addEventListener("keydown",e=>{const b=e.target.closest&&e.target.closest(".jlc-bundle");if(b&&(e.key==="Enter"||e.key===" ")){e.preventDefault();window.jlSelectBundle(b.dataset.p);}});
  }

  /* sticky picker (drop-up) — mit Tastatur: Pfeile bewegen, Enter/Leertaste waehlt, Escape schliesst */
  if(stickySel){
    const btn=stickySel.querySelector(".jlc-sticky-sel__btn"),opts=()=>[...stickySel.querySelectorAll("li")];
    const toggle=o=>{stickySel.classList.toggle("jlc-open",o);btn.setAttribute("aria-expanded",o);
      if(o){const cur=opts().find(li=>li.getAttribute("aria-selected")==="true")||opts()[0];if(cur)cur.focus();}};
    btn.addEventListener("click",()=>toggle(!stickySel.classList.contains("jlc-open")));
    btn.addEventListener("keydown",e=>{if(e.key==="ArrowUp"||e.key==="ArrowDown"){e.preventDefault();toggle(true);}});
    opts().forEach(li=>{
      li.addEventListener("click",()=>{select(li.dataset.p);toggle(false);});
      li.addEventListener("keydown",e=>{
        const l=opts(),i=l.indexOf(li);
        if(e.key==="ArrowDown"){e.preventDefault();(l[i+1]||l[0]).focus();}
        else if(e.key==="ArrowUp"){e.preventDefault();(l[i-1]||l[l.length-1]).focus();}
        else if(e.key==="Enter"||e.key===" "){e.preventDefault();select(li.dataset.p);toggle(false);btn.focus();}
        else if(e.key==="Tab")toggle(false);
      });
    });
    document.addEventListener("click",e=>{if(!stickySel.contains(e.target))toggle(false);});
    document.addEventListener("keydown",e=>{if(e.key==="Escape"&&stickySel.classList.contains("jlc-open")){toggle(false);btn.focus();}});
  }
  /* bundle-repeat section (25) rendered later / re-rendered in the editor: mount there too */
  document.addEventListener("shopify:section:load",e=>e.target.querySelectorAll("[data-buy-mount]").forEach(m=>{if(!m.children.length){m.appendChild(tpl.content.cloneNode(true));render();}}));
  /* sticky bar: erscheint, sobald der Haupt-ATC nach oben rausgescrollt ist — und verschwindet
     wieder, solange irgendein Kaufbutton (auch der in JLC 25) im Bild ist. Vorher blieb sie bis
     zum Seitenende stehen und hat den zweiten Kaufblock und den Footer verdeckt. */
  if(sticky){
    const anchor=sec.querySelector("[data-buy-main] .jlc-btn");
    const buyBtns=()=>[...document.querySelectorAll("[data-buy-mount] .jlc-btn")];
    const anyBuyVisible=()=>buyBtns().some(b=>{const r=b.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;});
    const st=()=>{
      const on=!!anchor&&anchor.getBoundingClientRect().bottom<0&&!anyBuyVisible();
      sticky.classList.toggle("jlc-show",on);
      document.body.classList.toggle("jlc-sticky-on",on);
    };
    addEventListener("scroll",st,{passive:true});addEventListener("resize",st);st();
  }
  /* Desktop: die linke Spalte (Galerie + Videostreifen) ist sticky. Ist sie hoeher als der
     Viewport, soll sie mit der Unterkante einrasten, sonst sind die Videos nie zu sehen. */
  const col=sec.querySelector(".jlc-buy-wrap>div:first-child");
  if(col){
    const colTop=()=>{
      if(innerWidth<900){col.style.removeProperty("--jlc-col-top");return;}
      const h=col.offsetHeight,free=innerHeight-100-24;
      col.style.setProperty("--jlc-col-top",(h>free?innerHeight-h-24:100)+"px");
    };
    colTop();addEventListener("resize",colTop);addEventListener("load",colTop);
    if("ResizeObserver" in window)new ResizeObserver(colTop).observe(col);
  }
  /* Scarcity-Puls nur, solange der Kaufblock im Bild ist */
  if("IntersectionObserver" in window){
    const sio=new IntersectionObserver(es=>es.forEach(e=>{e.target.classList.toggle("jlc-anim",e.isIntersecting);if(e.isIntersecting)e.target.classList.add("jlc-grown");}),{threshold:.1});
    document.querySelectorAll(".jlc-scar").forEach(s=>sio.observe(s));
  }else document.querySelectorAll(".jlc-scar").forEach(s=>s.classList.add("jlc-anim","jlc-grown"));
  /* accordion: one open at a time. Nach dem Aufklappen max-height auf none, sonst wurde der
     Inhalt beim Drehen des Geraets oder bei Bildern im Text abgeschnitten. */
  sec.querySelectorAll("[data-acc] .jlc-acc-head").forEach(h=>h.addEventListener("click",()=>{
    const item=h.parentElement,open=item.hasAttribute("open");
    sec.querySelectorAll("[data-acc] .jlc-acc-item").forEach(i=>{
      const b=i.querySelector(".jlc-acc-body");
      if(i.hasAttribute("open")){b.style.maxHeight=b.scrollHeight+"px";b.offsetHeight;}
      i.removeAttribute("open");b.style.maxHeight="";
      i.querySelector(".jlc-acc-sign").textContent="+";i.querySelector(".jlc-acc-head").setAttribute("aria-expanded","false");
    });
    if(!open){
      item.setAttribute("open","");const b=item.querySelector(".jlc-acc-body");
      b.style.maxHeight=b.scrollHeight+"px";h.querySelector(".jlc-acc-sign").textContent="−";h.setAttribute("aria-expanded","true");
      const done=ev=>{if(ev.propertyName!=="max-height")return;b.removeEventListener("transitionend",done);if(item.hasAttribute("open"))b.style.maxHeight="none";};
      b.addEventListener("transitionend",done);
    }
  }));
  /* hero video strip: Pfeile, Punkte, Loop und Drag macht jlc-base.js (data-rail data-loop);
     hier nur die stummen Inline-Videos starten */
  const hv=sec.querySelector("[data-hero-vids]");
  if(hv&&window.jlInlineVideos)window.jlInlineVideos(hv);
  select(pkg,true);
});

/* 12 ATC — der Button legt per AJAX in den Warenkorb. Was danach passiert, steuert das Setting
   atc_target (data-target am Formular): "checkout" schickt die Seite sofort auf /checkout, der
   Button bleibt solange im Ladezustand (aria-busy, Spinner aus jlc-base.css). "drawer" rendert
   die Drawer-Section neu und oeffnet sie; laesst sich der Drawer nicht sichtbar machen, fuehrt
   der letzte Ausweg auf /cart. Steht selling_plan im Formular, geht er mit in den Warenkorb,
   damit die Zeile als Abo im Checkout landet. */
(function(){
  var form=document.getElementById("jlc-product-form");
  if(!form||form.dataset.jlcAjax)return;
  form.dataset.jlcAjax="1";
  var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/";
  function drawerEl(){return document.querySelector("cart-drawer");}
  function swap(html,sel,target){
    if(!html||!target)return;
    var fresh=new DOMParser().parseFromString(html,"text/html").querySelector(sel);
    if(fresh)target.innerHTML=fresh.innerHTML;
  }
  form.addEventListener("submit",function(e){
    e.preventDefault();
    if(form.dataset.jlcBusy)return;   /* zweiter Klick waehrend des Ladens: ignorieren, sonst liegt der Artikel doppelt drin */
    var idInput=form.querySelector("[name=id]"),qtyInput=form.querySelector("[name=quantity]"),planInput=form.querySelector("[name=selling_plan]");
    if(!idInput)return;
    form.dataset.jlcBusy="1";
    var btns=document.querySelectorAll('button[form="jlc-product-form"][name="add"]');
    btns.forEach(function(b){b.setAttribute("aria-busy","true");});
    var toCheckout=(form.dataset.target||"drawer")==="checkout";
    var drawer=toCheckout?null:drawerEl();
    var item={id:parseInt(idInput.value,10),quantity:parseInt(qtyInput&&qtyInput.value,10)||1};
    if(planInput&&planInput.value)item.selling_plan=parseInt(planInput.value,10);
    var items=[item];
    var fId=form.querySelector("[data-free-id]"),fQty=form.querySelector("[data-free-qty]"),fNote=form.querySelector("[data-free-note]");
    if(fId&&fId.value&&fQty&&parseInt(fQty.value,10)>0){
      var free={id:parseInt(fId.value,10),quantity:parseInt(fQty.value,10)};
      if(fNote&&fNote.value)free.properties={"Zugabe":fNote.value};
      items.push(free);
    }
    var body={items:items};
    if(drawer){body.sections="cart-drawer,cart-icon-bubble";body.sections_url=window.location.pathname;}
    /* Zwei getrennte Ketten. Vorher fing EIN catch alles: auch einen Fehler, der erst nach
       erfolgreichem Add beim Aktualisieren des Drawers passierte — Reaktion war ein nativer
       Formular-Submit, also ein zweiter POST und der Artikel lag doppelt im Warenkorb.
       Jetzt: schlaegt der Request fehl → nativ abschicken (Artikel ist noch nicht drin).
       Schlaegt danach die UI fehl → einfach auf /cart, der Artikel ist bereits drin. */
    var added=false;
    /* Direkt zum Checkout heisst: genau dieses Bundle kaufen. Deshalb vorher leeren, sonst lag
       nach Zurueck und erneutem Klick das alte Bundle noch mit drin (doppelter Preis). */
    (toCheckout?fetch(root+"cart/clear.js",{method:"POST",headers:{Accept:"application/json"}}):Promise.resolve())
      .then(function(){return fetch(root+"cart/add.js",{method:"POST",headers:{"Content-Type":"application/json",Accept:"application/javascript"},body:JSON.stringify(body)});})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d&&d.status)throw new Error(d.description||d.message||"add failed");
        added=true;
        return d;
      })
      .then(function(d){
        try{
          if(toCheckout){window.location.href=root+"checkout";return;}
          if(!drawer){window.location.href=root+"cart";return;}
          if(d.sections){
            swap(d.sections["cart-drawer"],"cart-drawer",drawer);
            swap(d.sections["cart-icon-bubble"],".shopify-section",document.getElementById("cart-icon-bubble"));
          }
          drawer.classList.remove("is-empty");
          document.dispatchEvent(new CustomEvent("cartQuantityUpdated"));
          if(typeof drawer.open==="function"){try{drawer.open();}catch(err){}}
          drawer.classList.add("active");
          var inner=document.getElementById("CartDrawer");
          if(inner)inner.classList.add("active");
          /* Scroll-Lock erst, wenn der Drawer wirklich im Bild ist; sonst blieb die Seite
             gesperrt, ohne dass etwas zu sehen war. Nach zwei Frames plus Animationszeit messen. */
          setTimeout(function(){
            var r=drawer.getBoundingClientRect(),vis=r.width>0&&r.height>0&&r.left<window.innerWidth&&getComputedStyle(drawer).visibility!=="hidden";
            if(vis)document.body.classList.add("overflow-hidden");
            else window.location.href=root+"cart";
          },450);
        }catch(err){window.location.href=root+"cart";}
      })
      .catch(function(){
        if(added){window.location.href=root+"cart";return;}
        form.removeAttribute("data-jlc-ajax");HTMLFormElement.prototype.submit.call(form);
      })
      .then(function(){
        /* Beim Sprung zum Checkout bleibt der Spinner stehen, bis die neue Seite da ist. */
        if(toCheckout&&added)return;
        delete form.dataset.jlcBusy;btns.forEach(function(b){b.removeAttribute("aria-busy");});
      });
  });
  /* Zurueck vom Checkout: der Browser holt die Seite aus dem Back-Forward-Cache, samt Spinner
     und gesetztem jlcBusy. Der Button drehte dann endlos und nahm keinen Klick mehr an.
     Icon und Drawer zeigen ausserdem noch den Warenkorb von vor dem Klick, also neu holen.
     Das gilt auch, wenn Chrome die Seite nicht aus dem Cache holt, sondern das HTML von damals
     aus dem HTTP-Cache neu aufbaut (persisted ist dann false, der Navigationstyp back_forward). */
  window.addEventListener("pageshow",function(e){
    var nav=performance.getEntriesByType&&performance.getEntriesByType("navigation")[0];
    if(!e.persisted&&!(nav&&nav.type==="back_forward"))return;
    delete form.dataset.jlcBusy;
    document.querySelectorAll('button[form="jlc-product-form"][name="add"]').forEach(function(b){b.removeAttribute("aria-busy");});
    fetch(root+"?sections=cart-drawer,cart-icon-bubble",{cache:"no-store"}).then(function(r){return r.json();}).then(function(s){
      var drawer=drawerEl();
      swap(s["cart-icon-bubble"],".shopify-section",document.getElementById("cart-icon-bubble"));
      swap(s["cart-drawer"],"cart-drawer",drawer);
      var fresh=s["cart-drawer"]&&new DOMParser().parseFromString(s["cart-drawer"],"text/html").querySelector("cart-drawer");
      if(drawer&&fresh)drawer.classList.toggle("is-empty",fresh.classList.contains("is-empty"));
    }).catch(function(){});
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-reasons-carousel"] && !Shopify.designMode) return;
  try {
    
/* Siegel-Zaehler: Zahl unter dem Band laeuft beim ersten Einblenden von 0 hoch, Haken zeichnet sich.
   Die Rail klont Karten fuer den Endlos-Loop, deshalb auch spaeter eingefuegte Siegel beobachten. */
(function(){
  var fmt=function(n){return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');};
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion:reduce)').matches;
  function run(el){
    el.classList.add('is-on');if(el.dataset.rsDone)return;el.dataset.rsDone='1';
    var t=el.querySelector('.jlc-rs-cnt'),end=parseInt(el.dataset.count,10)||0,suf=el.dataset.suffix||'';
    if(!t||!end||reduce)return;
    var t0=performance.now(),d=1600;
    (function step(now){var p=Math.min(1,(now-t0)/d),e=1-Math.pow(1-p,3);t.textContent=fmt(end*e)+(p>=1?suf:'');if(p<1)requestAnimationFrame(step);})(t0);
  }
  var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){run(e.target);io.unobserve(e.target);}});},{threshold:.4}):null;
  var seen=[];
  function scan(root){(root||document).querySelectorAll('[data-rs-seal]').forEach(function(el){if(seen.indexOf(el)>-1)return;seen.push(el);io?io.observe(el):run(el);});}
  scan();
  if('MutationObserver' in window){new MutationObserver(function(){scan();}).observe(document.body,{childList:true,subtree:true});}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-results-2"] && !Shopify.designMode) return;
  try {
    
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-hw]",el=>{
  if(!("IntersectionObserver" in window))return;
  new IntersectionObserver(es=>es.forEach(e=>el.classList.toggle("jlc-off",!e.isIntersecting))).observe(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-review-list"] && !Shopify.designMode) return;
  try {
    
/* 26 Bewertungsliste. Ausloeser sind der eigene Knopf unter der Liste und, falls gesetzt,
   der Link "Mehr Bewertungen lesen" in JLC 16 — beide tragen [data-review-more].
   Frueher gab es nur den Link; stand dessen Text im Editor leer, war der Rest der Liste
   nicht erreichbar. Und versteckt wurde nur der geklickte Ausloeser, nicht der andere. */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-review-list]",list=>{
  const shown=document.querySelector("[data-review-shown]"),count=document.querySelector("[data-review-count]");
  const step=+list.dataset.step||3;
  const btns=()=>document.querySelectorAll("[data-review-more]");
  const sync=()=>{
    const vis=list.querySelectorAll(".jlc-rev:not([hidden])").length;
    if(shown)shown.textContent=vis;
    if(!list.querySelector(".jlc-rev[hidden]")){
      btns().forEach(b=>{const w=b.closest(".jlc-more-wrap");(w||b).hidden=true;});
      if(count)count.textContent=list.dataset.allLabel;
    }
  };
  btns().forEach(btn=>btn.addEventListener("click",e=>{
    e.preventDefault();
    const fresh=[...list.querySelectorAll(".jlc-rev[hidden]")].slice(0,step);
    fresh.forEach(el=>el.hidden=false);
    /* jlClampReviews misst die neuen Karten jetzt nach (vorher wurden sie uebersprungen
       und lange Texte blieben ohne "Weiterlesen"). Fokus auf die erste neue Karte, damit
       die Tastatur nicht ins Leere faellt, wenn der Knopf verschwindet. */
    if(window.jlClampReviews)window.jlClampReviews(list);
    if(fresh[0]){fresh[0].setAttribute("tabindex","-1");fresh[0].focus({preventScroll:true});}
    sync();
  }));
  sync();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-stats-2"] && !Shopify.designMode) return;
  try {
    
/* 14 stats — count-up over 1.2s when 35% visible. Numbers render fully formatted first, so nothing breaks without JS. */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-stats]",box=>{
  const fmt=(el,v)=>(el.dataset.fmt==="de"?v.toLocaleString("de-DE"):v)+(el.dataset.suf||"");
  box.querySelectorAll("[data-to]").forEach(el=>el.textContent=fmt(el,+el.dataset.to));
  /* Reduced Motion: die Zahlen stehen sofort, kein Hochzaehlen */
  if(!("IntersectionObserver" in window)||(matchMedia&&matchMedia("(prefers-reduced-motion:reduce)").matches))return;
  new IntersectionObserver((en,ob)=>en.forEach(e=>{if(!e.isIntersecting)return;ob.unobserve(e.target);
    e.target.querySelectorAll("[data-to]").forEach(el=>{const to=+el.dataset.to,t0=performance.now();
      (function step(t){const p=Math.min(1,(t-t0)/1200),v=Math.round(to*(1-Math.pow(1-p,3)));
        el.textContent=fmt(el,v);if(p<1)requestAnimationFrame(step);})(t0);});
  }),{threshold:.35}).observe(box);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-stats"] && !Shopify.designMode) return;
  try {
    
/* 14 stats — count-up over 1.2s when 35% visible. Numbers render fully formatted first, so nothing breaks without JS. */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-stats]",box=>{
  const fmt=(el,v)=>(el.dataset.fmt==="de"?v.toLocaleString("de-DE"):v)+(el.dataset.suf||"");
  box.querySelectorAll("[data-to]").forEach(el=>el.textContent=fmt(el,+el.dataset.to));
  /* Reduced Motion: die Zahlen stehen sofort, kein Hochzaehlen */
  if(!("IntersectionObserver" in window)||(matchMedia&&matchMedia("(prefers-reduced-motion:reduce)").matches))return;
  new IntersectionObserver((en,ob)=>en.forEach(e=>{if(!e.isIntersecting)return;ob.unobserve(e.target);
    e.target.querySelectorAll("[data-to]").forEach(el=>{const to=+el.dataset.to,t0=performance.now();
      (function step(t){const p=Math.min(1,(t-t0)/1200),v=Math.round(to*(1-Math.pow(1-p,3)));
        el.textContent=fmt(el,v);if(p<1)requestAnimationFrame(step);})(t0);});
  }),{threshold:.35}).observe(box);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-survey"] && !Shopify.designMode) return;
  try {
    
/* 30 survey: Zahl zaehlt hoch, Balken fuellt sich, sobald 35 % sichtbar. Ohne JS steht alles fertig da. */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-survey]",box=>{
  if(!("IntersectionObserver" in window)||(matchMedia&&matchMedia("(prefers-reduced-motion:reduce)").matches))return;
  box.querySelectorAll("[data-w]").forEach(el=>el.style.width="0%");
  box.querySelectorAll("[data-to]").forEach(el=>el.textContent="0");
  new IntersectionObserver((en,ob)=>en.forEach(e=>{if(!e.isIntersecting)return;ob.unobserve(e.target);
    e.target.querySelectorAll("[data-w]").forEach(el=>el.style.width=el.dataset.w+"%");
    e.target.querySelectorAll("[data-to]").forEach(el=>{const to=+el.dataset.to,t0=performance.now();
      const step=now=>{const p=Math.min(1,(now-t0)/1200),v=Math.round(to*(1-Math.pow(1-p,3)));el.textContent=v;if(p<1)requestAnimationFrame(step);};
      requestAnimationFrame(step);});
  }),{threshold:.35}).observe(box);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-testimonials-2"] && !Shopify.designMode) return;
  try {
    
/* Experten blättern: Pfeile, auf dem Handy auch wischen. Kein Autoplay. */
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})("[data-xp]", function (box) {
  if (box.dataset.jlcXp) return;
  box.dataset.jlcXp = "1";
  var slides = box.querySelectorAll("[data-xp-slide]");
  var prev = box.querySelector("[data-xp-prev]"), next = box.querySelector("[data-xp-next]");
  if (slides.length < 2 || !prev || !next) return;
  var i = 0;
  function go(n) {
    i = Math.max(0, Math.min(slides.length - 1, n));
    slides.forEach(function (el, k) {
      el.classList.toggle("is-on", k === i);
      if (k === i) el.removeAttribute("aria-hidden"); else el.setAttribute("aria-hidden", "true");
    });
    prev.disabled = i === 0;
    next.disabled = i === slides.length - 1;
  }
  /* Autoplay (Setting autoplay in Sekunden, 0 = aus): weiter bis zum Ende, dann wieder von vorn. Stoppt fuer immer,
     sobald jemand selbst klickt, wischt oder die Maus darueber haelt. Laeuft erst, wenn die Section im Bild ist. */
  var dur = (matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) ? 0 : (+box.dataset.auto || 0) * 1000, timer = null, stopped = false, bar = box.querySelector("[data-xp-prog]");
  if (bar) box.style.setProperty("--xp-dur", (dur / 1000) + "s");
  function restartBar() { if (!bar) return; bar.classList.remove("run"); void bar.offsetWidth; bar.classList.add("run"); }
  function tick() { clearTimeout(timer); if (stopped || !dur) return; restartBar(); timer = setTimeout(function () { go(i + 1 >= slides.length ? 0 : i + 1); tick(); }, dur); }
  function stop() { stopped = true; clearTimeout(timer); if (bar) { bar.classList.remove("run"); bar.parentNode.style.visibility = "hidden"; } }
  prev.addEventListener("click", function () { stop(); go(i - 1); });
  next.addEventListener("click", function () { stop(); go(i + 1); });
  box.addEventListener("mouseenter", stop);
  box.addEventListener("touchstart", stop, { passive: true });
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { box.classList.add("jlc-xp-seen"); io.disconnect(); tick(); } }); }, { threshold: .35 });
    io.observe(box);
  } else { box.classList.add("jlc-xp-seen"); tick(); }
  var x0 = null;
  box.addEventListener("touchstart", function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  box.addEventListener("touchend", function (e) {
    if (x0 === null) return;
    var dx = e.changedTouches[0].clientX - x0; x0 = null;
    if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
  });
  /* Theme-Editor: angeklickten Block zeigen */
  box.addEventListener("shopify:block:select", function (e) {
    slides.forEach(function (el, k) { if (el.contains(e.target) || el === e.target) go(k); });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-testimonials"] && !Shopify.designMode) return;
  try {
    
/* Fotostreifen: so oft verdoppeln, bis der Balken mindestens zweimal so breit ist wie
   sein Fenster, und die Dauer an die Breite koppeln, damit das Tempo gleich bleibt.
   Damit ist es egal, wie viele Fotos gepflegt sind. */
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})("[data-strip]", function (box) {
  var track = box.querySelector(".jlc-strip-track");
  if (!track || track.dataset.jlcRun) return;
  track.dataset.jlcRun = "1";
  var unit = track.scrollWidth / 2;
  if (!unit) return;
  var guard = 0;
  while (track.scrollWidth < box.clientWidth * 2 && guard < 4) {
    Array.prototype.slice.call(track.children).forEach(function (el) {
      track.appendChild(el.cloneNode(true));
    });
    guard++;
  }
  var px = track.scrollWidth / 2;
  track.style.animationDuration = Math.round(px / 40) + "s";
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-ticker-2"] && !Shopify.designMode) return;
  try {
    
/* Spur verdoppeln, bis sie mindestens 2x so breit ist wie das Fenster, Tempo mitziehen (wie JLC 19). */
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})("[data-lg]", function (box) {
  var track = box.querySelector(".jlc-lg-track");
  if (!track || track.dataset.jlcRun) return;
  track.dataset.jlcRun = "1";
  var copies = 4, guard = 0;
  while (track.scrollWidth < box.clientWidth * 2 && guard < 4) {
    Array.prototype.slice.call(track.children).forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute("aria-hidden", "true");
      c.removeAttribute("data-shopify-editor-block");
      track.appendChild(c);
    });
    copies *= 2; guard++;
  }
  if (copies > 4) {
    var base = parseFloat(getComputedStyle(box.parentNode).getPropertyValue("--tick-speed")) || 30;
    track.style.animationDuration = Math.round(base * copies / 4) + "s";
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-ticker"] && !Shopify.designMode) return;
  try {
    
/* 19 ticker — Spur verdoppeln, bis sie mindestens 2x so breit ist wie das Fenster, und die
   Dauer mitziehen, damit das Tempo (px/s) dem eingestellten Wert fuer vier Kopien entspricht. */
(window.jlcOnSection||function(s,f){document.querySelectorAll(s).forEach(f);})("[data-ticker]", function (box) {
  var track = box.querySelector(".jlc-tick-track");
  if (!track || track.dataset.jlcRun) return;
  track.dataset.jlcRun = "1";
  var copies = 4, guard = 0;
  while (track.scrollWidth < box.clientWidth * 2 && guard < 4) {
    Array.prototype.slice.call(track.children).forEach(function (el) {
      var c = el.cloneNode(true);
      c.setAttribute("aria-hidden", "true");
      c.removeAttribute("data-shopify-editor-block");
      track.appendChild(c);
    });
    copies *= 2; guard++;
  }
  if (copies > 4) {
    var base = parseFloat(getComputedStyle(box).getPropertyValue("--tick-speed")) || 28;
    track.style.animationDuration = Math.round(base * copies / 4) + "s";
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jlc-video-testimonials"] && !Shopify.designMode) return;
  try {
    
/* 24 video testimonials — die Kacheln laufen stumm im Streifen, ein Klick schaltet den Ton */
(window.jlcOnSection||((s,f)=>document.querySelectorAll(s).forEach(f)))("[data-video-section]",sec=>{
  if(window.jlInlineVideos)window.jlInlineVideos(sec);
});

  } catch(e) { console.error(e); }
})();
})();
